var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcEmoji = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16 4.25C9.51 4.25 4.25 9.51 4.25 16S9.51 27.75 16 27.75 27.75 22.49 27.75 16 22.49 4.25 16 4.25M5.75 16c0-5.66 4.589-10.25 10.25-10.25S26.25 10.34 26.25 16 21.66 26.25 16 26.25 5.75 21.66 5.75 16m6.125 2.064a.8.8 0 1 0-1.431.715c2.09 4.18 8.344 4.856 11.096.04a.8.8 0 0 0-1.389-.794c-2.09 3.659-6.733 3.125-8.276.039m1.706-5.891a.8.8 0 0 1 .8.8v2.422a.8.8 0 0 1-1.6 0v-2.422a.8.8 0 0 1 .8-.8m5.643.8a.8.8 0 0 0-1.6 0v2.422a.8.8 0 0 0 1.6 0z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEmoji);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };